\<template>
  <MCol :size="12">
    <div class="p-4 rounded border border-solid border-neutral-lighter">
      <MRow>
        <MCol :size="3">
          <FlotoFormItemReadOnly :label="$t('id')">
            {{ agenInformation.name || '---' }}
          </FlotoFormItemReadOnly>
        </MCol>
        <MCol :size="3">
          <FlotoFormItemReadOnly :label="$t('host_name')">
            <FlotoDot
              v-if="agentStatus"
              :bg="agentStatus"
              class="cursor-pointer mr-1"
              :size="15"
            />
            {{ agenInformation.hostName || '---' }}
          </FlotoFormItemReadOnly>
        </MCol>
        <MCol :size="3">
          <FlotoFormItemReadOnly :label="$t('ip_address')">
            {{ agenInformation.ipAddress || '---' }}
          </FlotoFormItemReadOnly>
        </MCol>
        <MCol :size="3">
          <FlotoFormItemReadOnly :label="$tc('poller')">
            <PollerConfigPicker
              as-input
              text-only
              disabled
              placeholder="---"
              :value="agenInformation.pollerId"
            />
          </FlotoFormItemReadOnly>
        </MCol>
        <MCol :size="3">
          <FlotoFormItemReadOnly :label="$t('os_component')">
            {{ agenInformation.osName || '---' }}
          </FlotoFormItemReadOnly>
        </MCol>
        <MCol :size="3">
          <FlotoFormItemReadOnly :label="$t('version')">
            {{ agenInformation.agentVersion || '---' }}
          </FlotoFormItemReadOnly>
        </MCol>
        <MCol :size="3">
          <FlotoFormItemReadOnly :label="$t('domain_name')">
            {{ agenInformation.domainName || '---' }}
          </FlotoFormItemReadOnly>
        </MCol>
        <MCol :size="3">
          <FlotoFormItemReadOnly :label="$t('agent_last_sync_date')">
            {{ agenInformation.lastRefreshCallTime | datetime }}
          </FlotoFormItemReadOnly>
        </MCol>
      </MRow>
    </div>
  </MCol>
</template>
<script>
import { getAgentByAssetApi } from '@modules/asset-management/api/discovery-agents-api'
import PollerConfigPicker from '@components/data-picker/poller-config-picker'
export default {
  name: 'AgentInformationTab',
  components: { PollerConfigPicker },
  props: {
    resourceId: { type: [String, Number], required: true },
    asset: { type: Object, required: true },
  },
  data() {
    return {
      agenInformation: {},
    }
  },
  computed: {
    agentStatus() {
      if (this.asset && this.asset.agentActiveStatus) {
        if (this.asset.agentActiveStatus === 'active') {
          return '#6bda7b'
        }
        if (this.asset && this.asset.agentActiveStatus === 'not_active') {
          return '#ffe000'
        }
        if (this.asset && this.asset.agentActiveStatus === 'not_applicable') {
          return ''
        }
      }
      return ''
    },
  },
  created() {
    this.getDiscoveryAgents()
  },
  methods: {
    getDiscoveryAgents() {
      return getAgentByAssetApi(this.resourceId).then((data) => {
        this.agenInformation = data
      })
    },
  },
}
</script>
